export default __webpack_public_path__ + "static/global-essay-event-80a1a56bfe89510724f65418ff190b93.png";